import { atom } from "recoil";
import { MarkerRequest } from "../../types/entity/map/MapInterface";

// 매물 유형 상태
export const housingTypeState = atom<string> ({
    key: "housingTypeState",
    default: "ALL",
})

// 임시 변경 상태 (하우징)
export const selectedTypeState = atom<string | null> ({
    key: "selectedTypeState",
    default: null,
})

// 임시 변경 상태 (계약)
export const selectedContractState = atom<string | null> ({
    key: "selectedContractState",
    default: null,
})
// 임시 변경 상태 (관리비)
export const maintenanceCostState = atom<boolean | undefined>({
    key: "maintenanceCostState",
    default : false,
})

// 임시 변경 상태 (대학교)
export const selectedTypeNumState = atom<number | null> ({
    key: "selectedTypeNumState",
    default: null,
})

export const selectedJjinFilterState = atom<[string, 'positive'][]>({
    key: "selectedJjinFilterState",
    default: [],
});

// 검색 키워드 상태
export const searchKeywordState = atom<string>({
    key: "searchKeywordState",
    default : "",
})

// 필터 상태 타입 정의
interface FilterStateType {
    reviewType: string;
    university: number | null;
    contractType: string | null;
    depositMin : number | null;
    depositMax : number | null;
    monthlyRentMin : number | null;
    monthlyRentMax : number | null;
    inMaintenanceCost : boolean | undefined;
    reviewKeyword : string[];
}

// 필터 상태
export const filterState = atom<FilterStateType>({
    key: "filterState",
    default :  {
        reviewType: "후기별",
        university: null,
        contractType: null,
        depositMin : null,
        depositMax : null,
        monthlyRentMin : null,
        monthlyRentMax : null,
        inMaintenanceCost : false,
        reviewKeyword : [],
      },
})

// 계약/가격 조건 필터 상태
export const depositRangeState = atom<[number|null, number|null]>({
    key : "depositRangeState",
    default : [null, null],
})

export const monthlyRentRangeState = atom<[number|null, number|null]>({
    key : "monthlyRentRangeState",
    default : [null, null],
})


// 지도 마커 데이터 상태
export const markersState = atom({
    key: "markersState",
    default: [],
  });

// 선택된 마커 정보 상태
export const selectedMarkerState = atom({
    key: "selectedMarkerState",
    default: null,
  });

// MapView 상태
export const mapViewState = atom<{
  center: { lat: number; lng: number } | null;
  bounds: MarkerRequest['bounds'] | null;
  level: number;
} | null>({
  key: 'mapViewState',
  default: null,
});